'use es6';

export default (() => {
  return Promise.resolve({
    enabled: false
  });
});